import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout/layout";
import Home from "./pages/Home/Home";
import Contacto from "./pages/Contact/Contact";
import AboutMe from "./pages/AboutMe/AboutMe";
import Proyecto from "./pages/Proyecto/Proyecto";
import Perfil from "./pages/Proyecto/Perfil/Perfil";
import Reel from "./pages/Proyecto/Reel/Reel";
import Polaroid from "./pages/Proyecto/Polaroid/Polaroid";
import AllProyecto from "./pages/Proyecto/AllProyecto";

const AppRouter = (props) => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/sobre-mi" element={<AboutMe />} />
          <Route exact path="/contacto" element={<Contacto />} />
          <Route path="/proyecto/:id" element={<AllProyecto />} />
          <Route path="/proyecto/:id/:sub" element={<Proyecto />} />
          <Route path="/proyecto/reel" element={<Reel />} />
          <Route path="/proyecto/perfil/:id" element={<Perfil />} />
          <Route exact path="/proyecto/publicaciones_" element={<Polaroid />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default AppRouter;
